import React from 'react';
import { Box, Container } from '@mui/material';
import ProfileManager from '../components/Profile/ProfileManager';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';

export default function ProfilePage() {
  const { currentUser } = useAuth();

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  return (
    <Container maxWidth="lg">
      <Box sx={{ 
        minHeight: '100vh',
        py: 4,
        //background: 'linear-gradient(180deg, #13141f 0%, #1f2034 100%)',
      }}>
        <ProfileManager />
      </Box>
    </Container>
  );
}
